import "semantic-ui-css/semantic.min.css";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import "animate.css/animate.compat.css";

// Set lang attribute for html element
export const onClientEntry = () => {
  document.documentElement.lang = "en"
}
